angular.module('impactx.dialog').directive('ixDynamicCompile', function ($compile) {
    return {
        scope: true,
        replace: true,
        link: function (scope, element, attrs) {
            var templateUrl, controller;

            attrs.$observe('templateUrl', function (value) {
                templateUrl = value;
                compile();
            });

            attrs.$observe('controller', function (value) {
                controller = value;
                compile();
            });

            function compile() {
                if (angular.isDefined(templateUrl) && angular.isDefined(controller)) {
                    var html = '<div ng-controller="' + controller + '" ng-include="\'' + templateUrl + '\'"></div>';
                    element.append(html);
                    $compile(element.contents())(scope);
                }
            }
        }
    };
});